import React from 'react';
import {
    Table,
    Column,
} from '../../../components/Common';
import { TranslateW } from '../../../Utils/Languages/Translate';
import Routes from '../../../routes';

const ServiceEvents = ({
    id = ''
}) => (
    <Table
        url={Routes.ServiceEvents.ByUserProfile(id)}
        tableHeader={TranslateW("serviceActivityView.service-events")}
        tableHeaderTooltipText={TranslateW("ServiceEventsDescription")}
        noResultText="Oops...It is empty here..."
        noResultText2="Create a new Service Event to get started."
    >
        <Column id='ServiceEventIDHeader' title="SERVICE EVENT ID" property="id" link="/ServiceEvent/" linkId="id" />
        <Column id='LocationName' title="Location" property="locationName" />
        <Column id='CityHeader' title="CITY" property="city" />
        <Column id='workOrderID' title="WORK ORDER ID" property="workOrderId" />
        <Column id='CustomerWorkNumberHeader' title="CUSTOMER WORK #" property="workOrderNumber" />
        <Column id='typeHeader' title="TYPE" property="type" />
        <Column id='leakRateSimulation.Input.service-date' title="SERVICE DATE" property="serviceDate" type="dateTime" />
        <Column id='serviceEventView.primary-technician' title="PRIMARY TECH" property="primaryTechnicianName" />
        <Column id='AssetNameHeader' title="ASSET NAME" property="assetName" />
        <Column id='leakRateSimulation.Input.net-gas-added' title="NET GAS ADDED" type="weight" property="netGasAdded" />
        <Column id='PerOccurranceLeakRateHeader' title="PER OCCURRANCE LEAK RATE %" property="leakRate" type="percentage" />
    </Table>
);

export default ServiceEvents;
